<app-data-grid
  [group]="group"
  [dataItems]="modifierExceptions"
  [columns]="columns"
  [state]="state"
  (dataStateChange)="onDataStateChanged($event)"
  (filterChange)="filterChanged($event)"
  [filterable]="'menu'"
  [fontSize]="fontSize"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="tierName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="restaurantName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="plu"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="panelName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template #toolbarTemplate>
    <div class="k-toolbar k-grid-toolbar custom-toolbar">
      <h4 class="m-0">Modifiers in Tier:</h4>
      &nbsp;
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="tiers"
          class="tier-dropdown"
          [(ngModel)]="selectedTier"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        >
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <span class="selected-tier">
              <fa-icon
                class="lock-icon"
                *ngIf="dataItem?.isLocked ?? false"
                [icon]="['fas', 'lock']"
              ></fa-icon>
              {{ dataItem?.name }} -
              <strong
                ><fa-icon
                  class="king-icon icon-text"
                  [icon]="['fas', 'crown']"
                ></fa-icon
                >{{ dataItem?.kingRestaurantName }}
              </strong></span
            >
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <div class="buttons-section">
        <app-grid-manager-toolbar
          [showConfig]="false"
          (exportToExcel)="exportExceptions()"
          [fontSize]="fontSize"
          (fontSizeChange)="fontSize = $event"
          [columns]="columns"
          [view]="'Delivery Exceptions'"
          [showImport]="[]"
          [showExport]="['Current Type']"
        ></app-grid-manager-toolbar>
      </div>
    </div>
  </ng-template>
</app-data-grid>
